module.exports = __webpack_public_path__ + "img/acount.15b5612f.svg";